export class UserNotFound extends Error
{
    type = "UserException";
}
